import gql from 'graphql-tag';

export default gql`
  fragment TravelersFragment on Order {
    travelers {
      id
      firstName
      lastName
      middleName
      suffix
      isPrimary
      type
      ssrs {
        code
        flightId
        title
        price {
          amount
          currency
        }
        additionalInfo
      }
    }
  }
`;
